const onPrint_doc = async () => {
  const preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
  const postHtml = '</body></html>';
  // Lấy nội dung HTML của phần tử có id 'content'
  const content = document.getElementById('print_page_container').innerHTML;
  // return;

  // Định nghĩa một template DOCX đơn giản
  const template = preHtml + content + postHtml;
  const blob = new Blob(['\ufeff', template], {
    type: 'application/msword',
  });
  // Specify link url
  const url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(template);

  // Tạo một thẻ a để tải xuống tập tin
  const downloadLink = document.createElement('a');
  downloadLink.href = url;
  downloadLink.download = 'document.doc';

  // Thêm thẻ a vào body và kích hoạt sự kiện click để tải xuống
  document.body.appendChild(downloadLink);
  downloadLink.click();

  // Xóa URL tạm thời sau khi tải xuống
  window.URL.revokeObjectURL(url);
};

const onPrintPage = (no_print_classes: string[] = []) => {
  let printStyleSheet: HTMLStyleElement | null = null;
  if (no_print_classes && no_print_classes?.length > 0) {
    const classNames = '.' + no_print_classes.join(',.');
    // Tạo một stylesheet cho trang in
    printStyleSheet = document.createElement('style');
    printStyleSheet.type = 'text/css';
    printStyleSheet.media = 'print';
    // Ẩn các phần tử có class "no-print"
    printStyleSheet.innerHTML = `${classNames} { display: none; }`;
    // Thêm stylesheet vào trang
    document.head.appendChild(printStyleSheet);
  }
  // Kích hoạt trình in
  window.print();

  // Xóa stylesheet sau khi in để tránh DOM lưu thẻ <style> cho lần in sau
  if (printStyleSheet) {
    document.head.removeChild(printStyleSheet);
  }
};

export { onPrintPage };
